module.exports = __webpack_public_path__ + "static/media/youtube.61795d46.svg";